<template>
	<div class="grid dashboard">
		<div class="col-12 md:col-6 lg:col-3">
			<div class="card overview-box flex flex-column pt-2 cyan-bgcolor solid-surface-text-color">
				<div class="flex align-items-center">
					<i class="pi pi-shopping-cart"></i>
					<h6 class="m-0" :class="{'pl-2': !isRTL, 'pr-2': isRTL}">Orders</h6>
					<div :class="{'ml-auto': !isRTL, 'mr-auto': isRTL}">
						<Button icon="pi pi-ellipsis-h" class="p-button-rounded p-button-text solid-surface-text-color" @click="toggleMenu"></Button>
						<Menu ref="menu" :popup="true" :model="items"></Menu>
					</div>
				</div>
				<div class="flex justify-content-between mt-3 flex-wrap">
					<div class="flex flex-column" style="width: 80px;">
						<span class="mb-1 fs-xlarge">640</span>
						<span class="overview-status p-1 fs-small">1420 Completed</span>
					</div>
					<div class="flex align-items-end">
						<Chart ref="overviewChartData5" type="line" :data="overviewChartData5" :options="overviewChartOptions2" responsive="true" :height="60" :width="160"></Chart>
					</div>
				</div>
			</div>
		</div>

		<div class="col-12 md:col-6 lg:col-3">
			<div class="card overview-box flex flex-column pt-2 orange-bgcolor solid-surface-text-color">
				<div class="flex align-items-center">
					<i class="pi pi-dollar"></i>
					<h6 class="m-0" :class="{'pl-2': !isRTL, 'pr-2': isRTL}">Revenue</h6>
					<div :class="{'ml-auto': !isRTL, 'mr-auto': isRTL}">
						<Button icon="pi pi-ellipsis-h" class="p-button-rounded p-button-text solid-surface-text-color" @click="toggleMenu"></Button>
						<Menu ref="menu" :popup="true" :model="items"></Menu>
					</div>
				</div>
				<div class="flex justify-content-between mt-3 flex-wrap">
					<div class="flex flex-column" style="width: 80px;">
						<span class="mb-1 fs-xlarge">$57K</span>
						<span class="overview-status p-1 fs-small">$9,640 Income</span>
					</div>
					<div class="flex align-items-end">
						<Chart ref="overviewChartData6" type="line" :data="overviewChartData6" :options="overviewChartOptions2" responsive="true" :height="60" :width="160"></Chart>
					</div>
				</div>
			</div>
		</div>

		<div class="col-12 md:col-6 lg:col-3">
			<div class="card overview-box flex flex-column pt-2 pink-bgcolor solid-surface-text-color">
				<div class="flex align-items-center">
					<i class="pi pi-users"></i>
					<h6 class="m-0" :class="{'pl-2': !isRTL, 'pr-2': isRTL}">Customers</h6>
					<div :class="{'ml-auto': !isRTL, 'mr-auto': isRTL}">
						<Button icon="pi pi-ellipsis-h" class="p-button-rounded p-button-text solid-surface-text-color" @click="toggleMenu"></Button>
						<Menu ref="menu" :popup="true" :model="items"></Menu>
					</div>
				</div>
				<div class="flex justify-content-between mt-3 flex-wrap">
					<div class="flex flex-column" style="width: 80px;">
						<span class="mb-1 fs-xlarge">8572</span>
						<span class="overview-status p-1 fs-small">25402 Registered</span>
					</div>
					<div class="flex align-items-end">
						<Chart ref="overviewChartData7" type="line" :data="overviewChartData7" :options="overviewChartOptions2" responsive="true" :height="60" :width="160"></Chart>
					</div>
				</div>
			</div>
		</div>

		<div class="col-12 md:col-6 lg:col-3">
			<div class="card overview-box flex flex-column pt-2 purple-bgcolor solid-surface-text-color">
				<div class="flex align-items-center">
					<i class="pi pi-comments"></i>
					<h6 class="m-0" :class="{'pl-2': !isRTL, 'pr-2': isRTL}">Comments</h6>
					<div :class="{'ml-auto': !isRTL, 'mr-auto': isRTL}">
						<Button icon="pi pi-ellipsis-h" class="p-button-rounded p-button-text solid-surface-text-color" @click="toggleMenu"></Button>
						<Menu ref="menu" :popup="true" :model="items"></Menu>
					</div>
				</div>
				<div class="flex justify-content-between mt-3 flex-wrap">
					<div class="flex flex-column" style="width: 80px;">
						<span class="mb-1 fs-xlarge">805</span>
						<span class="overview-status p-1 fs-small">85 Responded</span>
					</div>
					<div class="flex align-items-end">
						<Chart ref="overviewChartData8" type="line" :data="overviewChartData8" :options="overviewChartOptions2" responsive="true" :height="60" :width="160"></Chart>
					</div>
				</div>
			</div>
		</div>

		<div class="col-12 lg:col-4">
			<div class="card height-100 flex flex-column">
				<div class="flex justify-content-center p-3 rounded-normal content-alt-bgcolor">
					<img src="/layout/images/widgets/feature-faq.svg" alt="feature-faq">
				</div>
				<div class="flex flex-column align-items-center mt-3">
					<h5 class="mb-2">Frequently Asked Questions</h5>
					<p class="muted-text">We answer all your burning questions about Ultima, and some probably never even thought to ask.</p>
				</div>
				<div class="flex justify-content-between align-items-center pt-3 mt-auto">
					<small class="muted-text">46 Questions</small>
					<Button label="VIEW FAQ"></Button>
				</div>
			</div>
		</div>

		<div class="col-12 lg:col-4">
			<div class="card height-100 flex flex-column">
				<div class="flex justify-content-center p-3 rounded-normal content-alt-bgcolor">
					<img src="/layout/images/widgets/feature-onboarding.svg" alt="feature-onboarding">
				</div>
				<div class="flex flex-column align-items-center mt-3">
					<h5 class="mb-2">Onboarding</h5>
					<p class="muted-text">Follow the steps to start your Ultima adventure within a few days.</p>
				</div>
				<div class="flex justify-content-between align-items-center pt-3 mt-auto">
					<small class="muted-text">3 Steps Left</small>
					<Button label="VIEW STEPS"></Button>
				</div>
			</div>
		</div>

		<div class="col-12 lg:col-4">
			<div class="card height-100 flex flex-column">
				<div class="flex justify-content-center p-3 rounded-normal content-alt-bgcolor">
					<img src="/layout/images/widgets/feature-security.svg" alt="feature-security">
				</div>
				<div class="flex flex-column align-items-center mt-3">
					<h5 class="mb-2">Security Center</h5>
					<p class="muted-text">Security surveillance management and threat protection for your Ultima cloud workloads.</p>
				</div>
				<div class="flex justify-content-between align-items-center pt-3 mt-auto">
					<small class="muted-text">3 Steps Left</small>
					<Button label="VIEW CENTER"></Button>
				</div>
			</div>
		</div>
		<div class="col-12 lg:col-4">
			<div class="card height-100 flex flex-column">
				<div class="flex justify-content-center p-3 rounded-normal content-alt-bgcolor">
					<img src="/layout/images/widgets/feature-faq.svg" alt="feature-faq">
				</div>
				<div class="flex flex-column align-items-center mt-3">
					<h5 class="mb-2">Frequently Asked Questions</h5>
					<p class="muted-text">We answer all your burning questions about Ultima, and some probably never even thought to ask.</p>
				</div>
				<div class="flex justify-content-between align-items-center pt-3 mt-auto">
					<small class="muted-text">46 Questions</small>
					<Button label="VIEW FAQ"></Button>
				</div>
			</div>
		</div>

		<div class="col-12 lg:col-4">
			<div class="card height-100 flex flex-column">
				<div class="flex justify-content-center p-3 rounded-normal content-alt-bgcolor">
					<img src="/layout/images/widgets/feature-onboarding.svg" alt="feature-onboarding">
				</div>
				<div class="flex flex-column align-items-center mt-3">
					<h5 class="mb-2">Onboarding</h5>
					<p class="muted-text">Follow the steps to start your Ultima adventure within a few days.</p>
				</div>
				<div class="flex justify-content-between align-items-center pt-3 mt-auto">
					<small class="muted-text">3 Steps Left</small>
					<Button label="VIEW STEPS"></Button>
				</div>
			</div>
		</div>

		<div class="col-12 lg:col-4">
			<div class="card height-100 flex flex-column">
				<div class="flex justify-content-center p-3 rounded-normal content-alt-bgcolor">
					<img src="/layout/images/widgets/feature-security.svg" alt="feature-security">
				</div>
				<div class="flex flex-column align-items-center mt-3">
					<h5 class="mb-2">Security Center</h5>
					<p class="muted-text">Security surveillance management and threat protection for your Ultima cloud workloads.</p>
				</div>
				<div class="flex justify-content-between align-items-center pt-3 mt-auto">
					<small class="muted-text">3 Steps Left</small>
					<Button label="VIEW CENTER"></Button>
				</div>
			</div>
		</div>
		<div class="col-12 lg:col-4">
			<div class="card height-100 flex flex-column">
				<div class="flex justify-content-center p-3 rounded-normal content-alt-bgcolor">
					<img src="/layout/images/widgets/feature-faq.svg" alt="feature-faq">
				</div>
				<div class="flex flex-column align-items-center mt-3">
					<h5 class="mb-2">Frequently Asked Questions</h5>
					<p class="muted-text">We answer all your burning questions about Ultima, and some probably never even thought to ask.</p>
				</div>
				<div class="flex justify-content-between align-items-center pt-3 mt-auto">
					<small class="muted-text">46 Questions</small>
					<Button label="VIEW FAQ"></Button>
				</div>
			</div>
		</div>

		<div class="col-12 lg:col-4">
			<div class="card height-100 flex flex-column">
				<div class="flex justify-content-center p-3 rounded-normal content-alt-bgcolor">
					<img src="/layout/images/widgets/feature-onboarding.svg" alt="feature-onboarding">
				</div>
				<div class="flex flex-column align-items-center mt-3">
					<h5 class="mb-2">Onboarding</h5>
					<p class="muted-text">Follow the steps to start your Ultima adventure within a few days.</p>
				</div>
				<div class="flex justify-content-between align-items-center pt-3 mt-auto">
					<small class="muted-text">3 Steps Left</small>
					<Button label="VIEW STEPS"></Button>
				</div>
			</div>
		</div>

		<div class="col-12 lg:col-4">
			<div class="card height-100 flex flex-column">
				<div class="flex justify-content-center p-3 rounded-normal content-alt-bgcolor">
					<img src="/layout/images/widgets/feature-security.svg" alt="feature-security">
				</div>
				<div class="flex flex-column align-items-center mt-3">
					<h5 class="mb-2">Security Center</h5>
					<p class="muted-text">Security surveillance management and threat protection for your Ultima cloud workloads.</p>
				</div>
				<div class="flex justify-content-between align-items-center pt-3 mt-auto">
					<small class="muted-text">3 Steps Left</small>
					<Button label="VIEW CENTER"></Button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Widgets",
		data() {
			return {
				items: [
					{label: 'Update', icon: 'pi pi-fw pi-refresh'},
					{label: 'Edit', icon: 'pi pi-fw pi-pencil'}
				],
                chartData: null,
                chartOptions: null,
                overviewChartData5: {
                    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September'],
                    datasets: [{
                        data: [50,64,32,24,18,27,20,36,30],
                        borderColor: [
                            '#4DD0E1',
                        ],
                        backgroundColor: [
                            'rgba(77, 208, 225, 0.8)',
                        ],
                        borderWidth: 2,
                        fill: true,
                        tension: .4
                    }
                ]},
                overviewChartData6: {
                    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September'],
                    datasets: [{
                        data: [11,30,52,35,39,20,14,18,29],
                        borderColor: [
                            '#4DD0E1',
                        ],
                        backgroundColor: [
                            'rgba(77, 208, 225, 0.8)',
                        ],
                        borderWidth: 2,
                        fill: true,
                        tension: .4
                    }
                ]},
                overviewChartData7: {
                    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September'],
                    datasets: [{
                        data: [20,29,39,36,45,24,28,20,15],
                        borderColor: [
                            '#4DD0E1',
                        ],
                        backgroundColor: [
                            'rgba(77, 208, 225, 0.8)',
                        ],
                        borderWidth: 2,
                        fill: true,
                        tension: .4
                    }
                ]},
                overviewChartData8: {
                    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September'],
                    datasets: [{
                        data: [30,39,50,21,33,18,10,24,20],
                        borderColor: [
                            '#4DD0E1',
                        ],
                        backgroundColor: [
                            'rgba(77, 208, 225, 0.8)',
                        ],
                        borderWidth: 2,
                        fill: true,
                        tension: .4
                    }
                ]},
                overviewChartOptions2: {
                    plugins: {
                        legend: {
                            display: false
                        }
                    },
                    responsive: true,
                    scales: {
                        y: {
                            display: false
                        },
                        x: {
                            display: false
                        }
                    },
                    tooltips: {
                        enabled: false
                    },
                    elements: {
                        point:{
                            radius: 0
                        }
                    },
                },
            }
		},
        mounted() {
            this.refreshChart();
        },
        watch: {
            '$appState.isNewThemeLoaded'(isLoaded) {
                if (isLoaded) {
                    this.refreshChart();
                    this.$appState.isNewThemeLoaded = false;
                }
            }
        },
		methods: {
			toggleMenu(event) {
				this.$refs.menu.toggle(event);
			},
            refreshChart() {
                this.chartData = this.getChartData();
                this.chartOptions = this.getChartOptions();
                this.setOverviewColors();
            },
            getChartData() {
                const isLight = this.$appState.layoutMode === 'light';
                const completedColors = {
                    borderColor: isLight ? '#00ACC1' : '#4DD0E1',
                    backgroundColor: isLight ? 'rgb(0, 172, 193, .3)' : 'rgb(77, 208, 225, .3)'
                };
                const canceledColors = {
                    borderColor: isLight ? '#FF9800' : '#FFB74D',
                    backgroundColor: isLight ? 'rgb(255, 152, 0, .3)' : 'rgb(255, 183, 77, .3)'
                };

                return {
                    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                    datasets: [
                        {
                            label: 'Completed',
                            data: [65, 59, 80, 81, 56, 55, 40],
                            borderColor: completedColors.borderColor,
                            backgroundColor: completedColors.backgroundColor,
                            borderWidth: 2,
                            fill: true,
                            tension: .4
                        },
                        {
                            label: 'Cancelled',
                            data: [28, 48, 40, 19, 86, 27, 90],
                            borderColor: canceledColors.borderColor,
                            backgroundColor: canceledColors.backgroundColor,
                            borderWidth: 2,
                            fill: true,
                            tension: .4
                        }
                    ]
                };
            },
            getChartOptions() {
                const textColor = getComputedStyle(document.body).getPropertyValue('--text-color') || 'rgba(0, 0, 0, 0.87)';
                const gridLinesColor = getComputedStyle(document.body).getPropertyValue('--divider-color') || 'rgba(160, 167, 181, .3)';
                return {
                    plugins: {
                        legend: {
                            display: true,
                            labels: {
                                color: textColor
                            }
                        }
                    },
                    responsive: true,
                    scales: {
                        y: {
                            ticks: {
                                color: textColor
                            },
                            grid: {
                                color: gridLinesColor
                            }
                        },
                        x: {
                            ticks: {
                                color: textColor
                            },
                            grid: {
                                color: gridLinesColor
                            }
                        }
                    }
                }
            },
            getOverviewColors() {
                const isLight = this.$appState.layoutMode === 'light';
                return {
                    whiteBorderColor: isLight ? '#ffffff' : '#ffffff',
                    whiteBgColor: isLight ? 'rgba(255,255,255,.35)' : 'rgba(255,255,255,.35)',
                }
            },
            setOverviewColors() {
                const { whiteBgColor, whiteBorderColor} = this.getOverviewColors();

                this.overviewChartData5.datasets[0].borderColor[0] = whiteBorderColor;
                this.overviewChartData5.datasets[0].backgroundColor[0] = whiteBgColor;

                this.overviewChartData6.datasets[0].borderColor[0] = whiteBorderColor;
                this.overviewChartData6.datasets[0].backgroundColor[0] = whiteBgColor;

                this.overviewChartData7.datasets[0].borderColor[0] = whiteBorderColor;
                this.overviewChartData7.datasets[0].backgroundColor[0] = whiteBgColor;

                this.overviewChartData8.datasets[0].borderColor[0] = whiteBorderColor;
                this.overviewChartData8.datasets[0].backgroundColor[0] = whiteBgColor;

                this.$refs.overviewChartData5.reinit();
                this.$refs.overviewChartData6.reinit();
                this.$refs.overviewChartData7.reinit();
                this.$refs.overviewChartData8.reinit();
            }
		},
        computed: {
            isRTL() {
				return this.$appState.RTL;
			}
        }
	}
</script>

<style scoped>

</style>
